module.exports = __webpack_public_path__ + "img/home.7697b52f.png";